const html = require("./html/shippingReviewView.html");
const carrBrokerhtml = require("./html/shippingReviewCarrBrokerView.html");
import {setElementsFromScope, swapClasses, insertValAndManageFocus, insertTextAndClean, show, hide, handleDisplayFor, setUniqNamesAndIds, setRequired} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnDetailStore from "../../../stores/AsnDetailStore";
import AsnShippingPalletStore from "../../../stores/AsnShippingPalletStore";
import AsnStore from "../../../stores/AsnStore";
import ShippingMethodStore from "../../../stores/ShippingMethodStore";
import BrokerStore from "../../../stores/ShippingMethodStore";
import CaseArrivalAndTrackingRowView from "../ShippingTab/CaseArrivalAndTrackingRowView";
import AsnDetailRowsReviewView from "./AsnDetailRowsReviewView";
import AsnShippingPalletRowsReview from "./AsnShippingPalletRowsReview";
import PickupSchedulingReviewView from "./PickupSchedulingReviewView";
import ShippingQuoteReviewView from "./ShippingQuoteReviewView";
import {isPresent} from '../../../utilities/general';
import render from "../../../utilities/render";
const asnShippingPalletHtml = require("./html/reviewAsnShippingPalletTemplate.html");

const elementsMap = {
  inboundCarrierOuter: ".inbound-carrier-outer",
  asnDetailRowsReviewViewEntryPoint: ".asn-details-rows-view-entry-point",
  asnShippingPalletViewEntryPoint: ".asn-shipping-pallet-view-entry-point",
  caseArrivalAndTrackingRows: ".case-exp-arrival-tracking-rows",

  inboundCarrierText: ".inbound-carrier-text",
  inboundBrokerText: ".inbound-broker-text",

  inboundCarrierContainer: ".inbound-carrier",
  inboundBrokerContainer: ".inbound-broker",

  parcelPalletNoOtherContainers: ".parcel-pallet-no-other",
  contactNameText: ".contact-name-text",
  contactPhoneNumberText: ".contact-phone-number-text",

  estimatedArrivalDateContainer: '.estimated-arrival-date',
  estimatedArrivalDateText: '.estimated-arrival-date-text',

  trackingNumbersContainer: '.tracking-numbers',
  trackingNumbersText: '.tracking-numbers-text',

  palletNoContainers: ".pallet-no",
  bolProOuter: ".bol-pro-outer",
  bolProNumberText: ".bol-pro-number-text",
  expArrivalDateText: ".exp-arrival-date-text",

  pickupSchedulingReviewViewEntryPoint: ".pickup-scheduling-review-view-entry-point",
  shippingQuoteReviewViewEntryPoint: ".shipping-quote-review-view-entry-point",

  asnShippingPalletsContainer: ".review-asn-shipping-pallets-container",

  printShippingLabelYes: ".print-shipping-label-yes",
  printShippingLabelNo: ".print-shipping-label-no"
}
 
export default function ShippingReviewView(_unused, {
    getAsn,
    getAsnDetailGroups,
    isPallet,
    hasShippingPartner,
    isInboundCarrierOther,
    getSelectedQuoteForAsn,
    getAsnShipppingPallets
  }={}){

  const self = this;


  self._element = $();
  const els = {};
  let caseArrivalAndTrackingRowViews = [];
  let asn;

  self.init = function(){
    renderElements();
    populateAsnShippingPallets();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }


  function setWidgets(){
    // this only needs to be rendered ONCE,
    // It has it's own Store bindings to
    // rerender itself
    //renderAsnDetailRowsView();
    renderPickupSchedulingReviewView();
    renderShippingQuoteReviewView();
  }


  self.getElement = function(){
    return self._element;
  }

  function renderElements(){

    asn = getAsn();
    if(asn!=null && asn.asn_org_id!=="" &&  asn.asn_org_id!=null && !hasShippingPartner() && (asn.asn_org_id==undefined || asn.asn_org_id!=0 )){
      self._element = $(carrBrokerhtml);
    }else{
      self._element = $(html);
      asn.asn_org_id = null;
    }

    setElements();
    setWidgets();
    update();
    bindElements();
    bindStores();
  }

  function update(){
    updateSelf();
    //updateChildren();
  }

  function updateChildren(){
    if(!isPallet()){
      unbindAll(caseArrivalAndTrackingRowViews);
      caseArrivalAndTrackingRowViews = renderCaseArrivalAndTrackingRowViews();
      els.caseArrivalAndTrackingRows.html(extractElements(caseArrivalAndTrackingRowViews));
    }
  }

  function updateSelf(){
    updateValues();
    const asn = getAsn();
    const isPlt = isPallet();
    const hasPartner = hasShippingPartner();
    const isInboundOther = isInboundCarrierOther();
    const freightShipping = asn.freightShipping;
    // For:
    // Parcel OR Pallet with NO shipping partner AND "Other" Selected
    handleDisplayFor(els.parcelPalletNoOtherContainers, (!hasPartner && isInboundOther));

    // If not a partner, then show estimated arrival 
    handleDisplayFor(els.estimatedArrivalDateContainer, !hasPartner);

    // If it is case and not partner and freight shipping not selected, then show tracking number
    handleDisplayFor(els.trackingNumbersContainer, (!isPlt && !hasPartner && !freightShipping));

    // For Case specific arrival and tracking rows
    // Not pallet, and No partner
    handleDisplayFor(els.caseArrivalAndTrackingRows, (!isPlt && !hasPartner));
    handleDisplayFor(els.inboundCarrierContainer, (AsnStore.getCarrierBroker() =='carrier'));
    handleDisplayFor(els.inboundBrokerContainer, (AsnStore.getCarrierBroker() =='broker'));


    // WITH partner, WITH pallet OR parcel
    // need to show dimensions and weight
   
    handleDisplayFor(els.asnDetailRowsReviewViewEntryPoint, hasPartner);


    handleDisplayFor(els.palletNoContainers, (isPlt && !hasPartner));
    // If it is not partner AND (pallet OR case and not partner and freight shipping) is selected, then show BOL
    handleDisplayFor(els.bolProOuter, (!hasPartner && (isPlt || (!isPlt && freightShipping))));

    // is Pallet, AND has partner YES
    const hasAsnShippingPallets = AsnShippingPalletStore.getAllAsnShippingPallets();
    //const isPltAndHasPartner =  && hasPartner;

    const hasShippingPalletsAndHasPartner = (checkForPalletShipping(hasAsnShippingPallets) || isPlt) && hasPartner;
    const hasShippingPalletsAndHasPartnerAndQuote = asn.requestQuoteSuccess && hasPartner;
    handleDisplayFor(els.pickupSchedulingReviewViewEntryPoint, hasShippingPalletsAndHasPartner);
    handleDisplayFor(els.shippingQuoteReviewViewEntryPoint, hasShippingPalletsAndHasPartnerAndQuote);
    handleDisplayFor(els.asnShippingPalletsContainer, checkForPalletShipping(hasAsnShippingPallets));
    if(asn.printShippingLabelFlag){
      handleDisplayFor(els.printShippingLabelYes, true);
      handleDisplayFor(els.printShippingLabelNo, false);
    }else{
      handleDisplayFor(els.printShippingLabelYes, false);
      handleDisplayFor(els.printShippingLabelNo, true);
    } 
  }


  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", update);
    AsnStore.bindListener("asns:shipping_partner_changed", updateSelf);

    AsnDetailStore.bindListener("asn_details:add", update);
    AsnDetailStore.bindListener("asn_details:change", update);
    AsnDetailStore.bindListener("asn_details:remove", update);
    AsnShippingPalletStore.bindListener("asn_details:change", update);
    AsnShippingPalletStore.bindListener("asn_details:add", update);
    AsnStore.bindListener("asns:change", updateSelf);
  }

  self.unbindListeners = function(){

  }

  function bindElements(){

  }

  function updateValues(){
    const asn = getAsn();
    const isPlt = isPallet();
    const isInboundOther = isInboundCarrierOther();
    const hasPartner = hasShippingPartner();
    let inboundCarrierText = asn.asn_carrier_name;
    let inboundBrokerText = asn.asn_carrier_name;
    const freightShipping = asn.freightShipping;

    if(isInboundOther){
      // if inbound carrier is "Other",
      // then use the actual name they typed in
      // the additional text box
      inboundCarrierText = asn.asn_carrier_name;
    }
    if(AsnStore.getCarrierBroker() =='broker' && !hasPartner){
      insertTextAndClean(els.inboundBrokerText, inboundCarrierText);
    }else if(AsnStore.getCarrierBroker() =='carrier' && !hasPartner){
      insertTextAndClean(els.inboundCarrierText, inboundCarrierText);
    }else{
      insertTextAndClean(els.inboundCarrierText, getAsn().inboundCarrier);
    }
    insertTextAndClean(els.estimatedArrivalDateText, asn.asn_expected_arrival_date);

    if(isInboundOther){
      insertTextAndClean(els.contactNameText, asn.asn_carrier_contact_name);
      insertTextAndClean(els.contactPhoneNumberText, asn.asn_carrier_phone_code + ' ' + asn.asn_carrier_phone);
    }

    if(!isPlt && !freightShipping && !hasPartner && AsnStore.getAsnDetails(asn).length > 0) {
      insertTextAndClean(els.trackingNumbersText, AsnStore.getAsnDetails(asn)[0].asd_tracking_number);
    }

    if(!hasPartner && (isPlt || (!isPlt && freightShipping))) {
      insertTextAndClean(els.bolProNumberText, asn.asn_bol_pro_number);
    }
  }



  function getShippingMethods(){
    return ShippingMethodStore.dataAsArray();
  }

  function renderAsnDetailRowsView(){
    const asnDetailRowsReviewView = new AsnDetailRowsReviewView(null, {
      readOnly: true,
      getAsn,
      getAsnDetailGroups,
      isPallet
    });
    asnDetailRowsReviewView.init();
    els.asnDetailRowsReviewViewEntryPoint.html(asnDetailRowsReviewView.getElement());
  }

  function renderAsnShipppingPalletRowsView(){
    const asnShippingPalletRowsReview = new AsnShippingPalletRowsReview(null, {
      readOnly: true,
      getAsn,
      getAsnShipppingPallets
    });
    asnShippingPalletRowsReview.init();
    els.asnShippingPalletReviewEntryPoint.html(asnDetailRowsReviewView.getElement());
  }

  function renderShippingQuoteReviewView(){
    const shippingQuoteReviewView = new ShippingQuoteReviewView(null, {
      getAsn,
      isPallet,
      getQuote: getSelectedQuoteForAsn
    });
    shippingQuoteReviewView.init();
    els.shippingQuoteReviewViewEntryPoint.html(shippingQuoteReviewView.getElement());
  }

  function renderPickupSchedulingReviewView(){
    const pickupSchedulingReviewView = new PickupSchedulingReviewView(null, {
      getAsn,
      isPallet
    });
    pickupSchedulingReviewView.init();
    els.pickupSchedulingReviewViewEntryPoint.html(pickupSchedulingReviewView.getElement());
  }



  function renderCaseArrivalAndTrackingRowViews(){
    return _(getAsnDetailGroups()).map((asnDetailGroup, rowIdx)=>{
      // get the first asnDetail in the case,
      // as all these values should be the same for the given
      // CaseArrivalAndTrackingRowView
      const asnDetail = asnDetailGroup[0];
      const caseArrivalAndTrackingRowView = new CaseArrivalAndTrackingRowView(asnDetail, {
        readOnly: true,
        rowIdx
      });
      caseArrivalAndTrackingRowView.init();
      return caseArrivalAndTrackingRowView;
    });
  }

  function checkForPalletShipping(hasAsnShippingPalletsData){
    let hasAsnShippingPalletsLength = false;

    if(_.isEmpty(hasAsnShippingPalletsData)){
      hasAsnShippingPalletsLength = false;
    }else{
      hasAsnShippingPalletsLength = true;
    }

    return hasAsnShippingPalletsLength;
  }

  function populateAsnShippingPallets() {
    els.asnShippingPalletsContainer.html('');
    _(getAsnShippingPallets()).map((asnShippingPallet, rowIdx)=>{
      rowIdx = rowIdx + 1;
      //let ids = _(asnShippingPallet).pluck("id");
      const detailHtml = buildAsnShippingPallets(asnShippingPallet, rowIdx);
      els.asnShippingPalletsContainer.append(detailHtml);
    });
  }

   function buildAsnShippingPallets(asnShippingPallet, palletId){
    let numberOfPallets = 1;
    let palletLineNumber = 1;
   //const asnShippingPallet = getFirstAsnShippingPallet(ids);
    
    const asnShippingPalletEL = render(
      asnShippingPalletHtml, {
        packingTypeUpperCase: "Pallet",
        numberOfCasesOrPallets: "2",
        caseOrPalletLineNumber: palletId,
        length: asnShippingPallet.asp_pallet_length,
        width: asnShippingPallet.asp_pallet_width,
        height: asnShippingPallet.asp_pallet_height,
        weight: asnShippingPallet.asp_pallet_weight,
        stackable : asnShippingPallet.asp_pallet_stackable,
      });
    return asnShippingPalletEL;
  }

  function getAsnShippingPallets(){
    return AsnStore.getAsnShipppingPallets(getAsn());
  }


}


// WEBPACK FOOTER //
// ./src/pages/asns/ReviewTab/ShippingReviewView.js